export default __webpack_public_path__ + "static/media/Shopify_POS@2x.37d71099.png";